/* eslint-disable */
import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import Button from '../../../components/Button/Button'
import useBreakpoints from '../../../hooks/useBreakpoints'
import StarRating from '../../../components/StarRating/StarRating'
import { googleRating, appleRating } from 'lifesum-shared/reviews'
import { useInView } from 'react-intersection-observer'

import LogoApple from 'media/logo-apple.svg?svgr-webpack'
import LogoAndroid from 'media/logo-android.svg?svgr-webpack'
import LazyImage from 'js/components/LazyImage/LazyImage'
import awardApple from 'media/award-apple-2018.png'
import awardGoogle from 'media/award-google-play.png'
import awardAppleDimensions from 'media/award-apple-2018.png?dimensions'
import awardGoogleDimensions from 'media/award-google-play.png?dimensions'
import phone from '../assets/app-diary.png'
import phoneDimensions from '../assets/app-diary.png?dimensions'
import appIcon from 'media/app-icon.png'

type ReviewBlockProps = {
  type: 'google' | 'apple'
}

const ReviewBlock = ({ type }: ReviewBlockProps) => {
  const Logo = type === 'google' ? LogoAndroid : LogoApple
  return (
    <div className="first:mb-12">
      <span className="sr-only">
        {type === 'google' ? 'Google Play: ' : 'Apple AppStore: '}
      </span>
      <div className="flex">
        <Logo className="-mt-2" style={{ width: 24, height: 24 }} />
        <div className="ml-8">
          <StarRating rating={type === 'google' ? googleRating : appleRating} />
        </div>
      </div>
      <span className="sr-only">
        {type === 'google' ? googleRating : appleRating} average rating
      </span>
    </div>
  )
}

type AwardsBoxProps = {
  children: React.ReactNode
  top?: string
  bottom?: string
  left?: string
  right?: string
  delay: number
  className: string
  inView: boolean
}

const AwardsBox = ({
  inView,
  left,
  right,
  top,
  bottom,
  delay,
  className,
  children,
}: AwardsBoxProps) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    let timeout
    if (inView) {
      timeout = setTimeout(() => {
        setShow(true)
      }, delay)
    }
    return () => clearTimeout(timeout)
  }, [inView, delay])

  return (
    <li
      className={cn('absolute', className)}
      style={{
        left: left || 'auto',
        right: right || 'auto',
        top: top || 'auto',
        bottom: bottom || 'auto',
      }}
    >
      <div
        className={cn(
          'shadow-elevated bg-white',
          'border-1 border-Border',
          'rounded-8 lg:rounded-12',
          'py-4 px-6 lg:py-12 lg:px-16',
          'transform transition-all duration-1000',
          'opacity-0',
          show ? 'translate-y-0 opacity-100' : 'translate-y-6'
        )}
      >
        {children}
      </div>
    </li>
  )
}

export default function AppPromo() {
  const [inViewRef, inView] = useInView({ threshold: 0.8, triggerOnce: true })
  const { LG } = useBreakpoints()

  return null
  return (
    <div className="o-width-limiter">
      <div className="max-w-576 lg:max-w-768 mx-auto flex">
        <div className="mr-12 md:mr-40 lg:shrink-0 relative" ref={inViewRef}>
          <LazyImage
            src={phone}
            alt="Screenshot from the Lifesum app"
            height={phoneDimensions.height}
            width={phoneDimensions.width}
          />
          <ul>
            <AwardsBox
              inView={inView}
              top="-5%"
              right="-30%"
              delay={1000}
              className="transform scale-75 md:scale-100 origin-top-right"
            >
              <div
                className={cn(
                  'transform scale-75 lg:scale-100 origin-right lg:transform-none',
                  '-ml-40 px-4 lg:m-0 lg:p-0'
                )}
              >
                <ReviewBlock type="apple" />
                <ReviewBlock type="google" />
              </div>
            </AwardsBox>
            <AwardsBox
              inView={inView}
              bottom="17%"
              left="-10%"
              delay={1750}
              className="w-3/5 lg:-ml-64"
            >
              <LazyImage
                src={awardApple}
                alt="Editors’ Choice, App Store 2018"
                height={awardAppleDimensions.height}
                width={awardAppleDimensions.width}
              />
            </AwardsBox>
            <AwardsBox
              inView={inView}
              bottom="-3%"
              right="-20%"
              delay={2500}
              className="w-3/5"
            >
              <LazyImage
                src={awardGoogle}
                alt="Best of Google Play 2017 &amp; 2018"
                height={awardGoogleDimensions.height}
                width={awardGoogleDimensions.width}
              />
            </AwardsBox>
          </ul>
        </div>
        <div className="text-center my-auto">
          <img
            src={appIcon}
            alt=""
            className={cn(
              'w-32 h-32 md:w-40 md:h-40 lg:w-56 lg:h-56',
              'mb-12 lg:mb-20',
              'rounded-8 md:rounded-12 lg:rounded-16'
            )}
          />
          <h2 className="type-17-demibold md:type-24-bold lg:type-36-bold">
            Gain control of your nutrition intake and boost your health.
          </h2>
          <div className="lg:w-3/5 mx-auto">
            <Button
              className="mt-20 md:mt-32 lg:mt-48 mb-12 lg:mb-24"
              color="green"
              big={LG}
              block={LG}
              use={Link}
              to="/signup"
            >
              Sign up now
            </Button>
          </div>
          <a
            className={cn(
              'inline-block leading-small transition',
              'border-b-1 border-Border  hover:border-Type',
              'type-upper text-Type'
            )}
            href="/features"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  )
}
